<template>
<div :class="is_nested ? 'form-submission-card-content-child-item' : 'form-submission-card-content-child'">
    <response-question :question="question" />

    <!-- Keep as single line, adds blank spacing when multiline -->
    <div class="form-submission-card-content-free-text">{{ answer_computed }}</div>
</div>
</template>

<script>
import ResponseQuestion from "./ResponseQuestion.vue";

export default {
    components: {
        ResponseQuestion,
    },
    props: {
        question: {
            type: String,
            required: true,
        },
        answer: {
            type: String|Number,
            required: true,
        },
        is_nested: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        answer_computed() {
            const answer = this.answer.toString().trim();
            return answer?.length ? answer : '-';
        },
    },
}
</script>
